import { useContext } from 'react'
import translate from './translate'
import LanguageContext from './language.context'
import PropTypes from 'prop-types'

export default function Translate({ tr, ...params }) {
  const { language } = useContext(LanguageContext)

  const translation = translate(tr, params, language)
  return translation
}

Translate.propTypes = {
  tr: PropTypes.string.isRequired,
  html: PropTypes.bool,
}
